import api from "./api";

const API_URL = "/comment";

export const commentsService = {
     
    async addComment(commentData) { 
    const response = await api.post(API_URL, commentData);
    return response.data;  
},

async deleteComment(commentId) {
    const response = await api.delete(`${API_URL}/${commentId}`);
    return response.data;
}


}